import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LayerApi } from '../../../api/layer-api';
import { ESRI } from '../../../esri-loader-util';
import { InputConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { ThemeService } from '../../../services/theme.service';
import { isClassBreakInfo, isClassBreaksRenderer, isDynamicDataLayerSource, isGeometryDataSource, isMapImageLayer, isSimpleRenderer, isSymbolPropertiesWithOutline, isUniqueValueRenderer } from '../../../types';
import { BaseComponent } from '../../base.component';
/* tslint:disable:cyclomatic-complexity */
var ThemeEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeEditorComponent, _super);
    function ThemeEditorComponent(_vcr, layerService, layerApi, cdr, themeService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.layerApi = layerApi;
        _this.cdr = cdr;
        _this.themeService = themeService;
        _this.renderers = [];
        _this.loadingData = false;
        _this.currentColors = [];
        _this.colorPickerClassNo = null;
        _this.defaultNumClasses = 5;
        _this.validationState = 'fresh';
        _this.classBreakChange = new Subject();
        _this.forceUniqueValues = false;
        _this.isNumericData = false;
        _this.isDate = false;
        _this.keepThemeOnOriginalLayer = false;
        _this.useEsriScheme = false;
        _this.useSymbolScheme = false;
        _this.minClasses = themeService.minMaxes.range.min;
        _this.maxClasses = themeService.minMaxes.range.max;
        _this.getClosestAncestor('mc-window').then(function (window) {
            if (window) {
                _this.windowRef = window;
                _this.windowRef.addEventListener('openChange', function (open) {
                    if (open.detail) {
                        _this.windowOpened();
                    }
                    else {
                        _this.destroySlider();
                        _this.destroyComponent();
                    }
                });
            }
            else {
                _this.windowOpened();
            }
        });
        return _this;
    }
    Object.defineProperty(ThemeEditorComponent.prototype, "layerId", {
        get: function () {
            return this._layerId;
        },
        set: function (value) {
            this._layerId = value;
        },
        enumerable: true,
        configurable: true
    });
    ThemeEditorComponent.prototype.watchClassBreaks = function () {
        var _this = this;
        this.classInputSub = this.classBreakChange.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(function () { return _this.generateRenderer(); });
    };
    ThemeEditorComponent.prototype.changeClassBreaks = function (event) {
        this.classBreakChange.next(event.currentTarget.value);
    };
    ThemeEditorComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        if (!this.mapViewRef) return [3 /*break*/, 1];
                        _b = this.mapViewRef;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 2:
                        _b = _c.sent();
                        _c.label = 3;
                    case 3:
                        _a.mapViewRef = _b;
                        this.themeService.mapView = this.mapViewRef;
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.windowOpened = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, layer, renderer;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            ESRI.Histogram,
                            ESRI.ClassedColorSlider
                        ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), this.Histogram = _a[0], this.ClassedColorSlider = _a[1];
                        layer = this.layerService.getEsriLayerByUniqueId(this.layerId);
                        if (!isMapImageLayer(layer)) return [3 /*break*/, 3];
                        this.layer = layer;
                        this.layerColumns = this.themeService.getLayerColumnsFromLayer(this.layer);
                        this.currentSubLayer = this.layer.sublayers.getItemAt(0);
                        this.currentColors = [];
                        renderer = this.currentSubLayer.renderer;
                        if (isSimpleRenderer(renderer)) {
                            this.classes.nativeElement.value = this.defaultNumClasses.toString();
                            this.symbol = [renderer.symbol];
                            this.selectedField = this.layerColumns[0].name;
                            this.layer.mapcoreProps.simpleRenderers = this.layerService.getRendererDefinitionsForLayer(this.layer);
                        }
                        else if (isClassBreaksRenderer(renderer)) {
                            this.keepThemeOnOriginalLayer = true;
                            this.classes.nativeElement.value = renderer.classBreakInfos.length.toString();
                            this.symbol = renderer.classBreakInfos.map(function (classBreak) { return classBreak.symbol; });
                            this.selectedField = renderer.field;
                        }
                        else if (isUniqueValueRenderer(renderer)) {
                            this.keepThemeOnOriginalLayer = true;
                            this.classes.nativeElement.value = renderer.uniqueValueInfos.length.toString();
                            this.symbol = renderer.uniqueValueInfos.map(function (classBreak) { return classBreak.symbol; });
                            this.selectedField = renderer.field;
                        }
                        this.watchClassBreaks();
                        return [4 /*yield*/, this.triggerRenderer()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3: throw new Error('Unsupported layer type for Theme Editor');
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.triggerRenderer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isUniqueValueRenderer(this.currentSubLayer.renderer) || isClassBreaksRenderer(this.currentSubLayer.renderer))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.generateRendererFromThemeLayer()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        this.resetValidation();
                        return [4 /*yield*/, this.generateRenderer()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.forceUpdateWithUniqueValues = function (forceUniqueValues) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.forceUniqueValues = forceUniqueValues;
                        this.updateMinMax();
                        return [4 /*yield*/, this.generateRenderer()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.resetValidation = function () {
        this.validationState = 'fresh';
    };
    Object.defineProperty(ThemeEditorComponent.prototype, "minError", {
        get: function () { return "This field has fewer than " + this.minClasses + " class breaks. Please try changing the layer filter or selecting a different field."; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeEditorComponent.prototype, "maxError", {
        get: function () { return "This field has more than " + this.maxClasses + " class breaks. Please try filtering the layer or selecting a different field."; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeEditorComponent.prototype, "uniqueValueInfoRenderers", {
        get: function () {
            return this.renderers.filter(isUniqueValueRenderer);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeEditorComponent.prototype, "classBreakInfoRenderers", {
        get: function () {
            return this.renderers.filter(isClassBreaksRenderer);
        },
        enumerable: true,
        configurable: true
    });
    ThemeEditorComponent.prototype.setInfos = function (infos) {
        var e_1, _a;
        this.classBreakInfos = [];
        this.numSelectedClasses = infos.length;
        this.classes.nativeElement.value = this.numSelectedClasses.toString();
        try {
            for (var infos_1 = tslib_1.__values(infos), infos_1_1 = infos_1.next(); !infos_1_1.done; infos_1_1 = infos_1.next()) {
                var info = infos_1_1.value;
                this.classBreakInfos.push(info);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (infos_1_1 && !infos_1_1.done && (_a = infos_1.return)) _a.call(infos_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ThemeEditorComponent.prototype.generateRendererFromThemeLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recordCount, selectedColumn, result, symbols, colorSets, minValue, maxValue, _a, _b, err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.errorMessage = null;
                        this.loadingData = true;
                        if (!((isUniqueValueRenderer(this.currentSubLayer.renderer) || isClassBreaksRenderer(this.currentSubLayer.renderer))
                            && isDynamicDataLayerSource(this.currentSubLayer.source) && isGeometryDataSource(this.currentSubLayer.source.dataSource))) return [3 /*break*/, 19];
                        this.selectedField = this.currentSubLayer.renderer.field;
                        this.forceUniqueValues = isUniqueValueRenderer(this.currentSubLayer.renderer);
                        this.updateMinMax();
                        this.setInfos(isUniqueValueRenderer(this.currentSubLayer.renderer) ? this.currentSubLayer.renderer.uniqueValueInfos : this.currentSubLayer.renderer.classBreakInfos);
                        return [4 /*yield*/, this.layerApi.getLayerRecordCount(this.layer.mapcoreProps.id || this.layer.mapcoreProps.parentId, this.layer.mapcoreProps.query)];
                    case 1:
                        recordCount = _c.sent();
                        if (!(recordCount && recordCount.length && recordCount[0].recordCount > 0)) return [3 /*break*/, 17];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 15, , 16]);
                        this.isDate = false;
                        selectedColumn = this.layer.mapcoreProps.columns.filter(function (x) { return x.name === _this.selectedField; });
                        if (selectedColumn && selectedColumn.length && selectedColumn.length > 0 && selectedColumn[0] && selectedColumn[0].databaseDataType && (selectedColumn[0].databaseDataType.toUpperCase() === 'DATE' || selectedColumn[0].name.toUpperCase().indexOf('DATE') > -1)) {
                            this.isDate = true;
                        }
                        return [4 /*yield*/, this.themeService.getLayerClassBreakData(this.layer.mapcoreProps.parentId, this.selectedField, this.numSelectedClasses, this.forceUniqueValues, JSON.parse(this.currentSubLayer.source.dataSource.query), this.isDate)];
                    case 3:
                        result = _c.sent();
                        this.isNumericData = result.IsNumericData;
                        if (!(result.ClassBreakInfos.length < this.minClasses)) return [3 /*break*/, 4];
                        this.errorMessage = this.minError;
                        return [3 /*break*/, 14];
                    case 4:
                        if (!(result.ClassBreakInfos.length > this.maxClasses)) return [3 /*break*/, 5];
                        this.errorMessage = this.maxError;
                        return [3 /*break*/, 14];
                    case 5:
                        if (!(result.ClassBreakInfos.length < this.minClasses && this.isNumericData && !this.forceUniqueValues)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.forceUpdateWithUniqueValues(true)];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 14];
                    case 7: return [4 /*yield*/, this.themeService.getSimpleLayerSymbols(this.layer)];
                    case 8:
                        symbols = _c.sent();
                        this.currentColors = this.themeService.getSublayerColors(this.layer.sublayers.getItemAt(0));
                        return [4 /*yield*/, this.getColorSets(result.ClassBreakInfos.length, symbols, this.currentColors)];
                    case 9:
                        colorSets = _c.sent();
                        this.histogramResult = result.Histogram;
                        if (!((this.isNumericData && !this.forceUniqueValues) && isClassBreakInfo(this.classBreakInfos))) return [3 /*break*/, 11];
                        minValue = result.ClassBreakInfos[0].minValue;
                        maxValue = result.ClassBreakInfos[result.ClassBreakInfos.length - 1].maxValue;
                        this.classBreakInfos[0].minValue = minValue;
                        this.classBreakInfos[this.classBreakInfos.length - 1].maxValue = maxValue;
                        _a = this;
                        return [4 /*yield*/, this.themeService.buildNumericRenderer(this.layer, this.selectedField, this.classBreakInfos, symbols, colorSets)];
                    case 10:
                        _a.renderers = _c.sent();
                        this.classBreakResult = {
                            classBreakInfos: this.classBreakInfos,
                            minValue: minValue,
                            maxValue: maxValue,
                            normalizationTotal: undefined
                        };
                        this.updateColorSlider(this.renderers[0], this.classBreakResult, this.histogramResult, this.newColorScheme);
                        this.appendFieldToLayerName(this.layer);
                        return [3 /*break*/, 13];
                    case 11:
                        _b = this;
                        return [4 /*yield*/, this.themeService.buildUniqueValueRenderer(this.layer, this.selectedField, this.classBreakInfos, symbols, colorSets)];
                    case 12:
                        _b.renderers = _c.sent();
                        this.appendFieldToLayerName(this.layer);
                        this.classes.nativeElement.disabled = true;
                        this.layerService.mapLayersSub.next();
                        _c.label = 13;
                    case 13:
                        this.layer.mapcoreProps.isThemed = true;
                        _c.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        err_1 = _c.sent();
                        this.errorMessage = 'There was an error loading data, please try again or contact an administrator.';
                        return [3 /*break*/, 16];
                    case 16: return [3 /*break*/, 18];
                    case 17:
                        this.errorMessage = 'No records for the current layer. Theme can\'t be applied.';
                        _c.label = 18;
                    case 18: return [3 /*break*/, 20];
                    case 19:
                        this.errorMessage = 'Error restoring theme layer properties.';
                        _c.label = 20;
                    case 20:
                        this.loadingData = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.generateRenderer = function (columnChange) {
        if (columnChange === void 0) { columnChange = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recordCount, selectedColumn, result, errorMessage, symbols, colorSets, _a, _b, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (columnChange) {
                            this.forceUniqueValues = false;
                            this.resetValidation();
                            this.updateMinMax();
                        }
                        this.errorMessage = null;
                        this.loadingData = true;
                        return [4 /*yield*/, this.layerApi.getLayerRecordCount(this.layer.mapcoreProps.id || this.layer.mapcoreProps.parentId, this.layer.mapcoreProps.query)];
                    case 1:
                        recordCount = _c.sent();
                        if (!(recordCount && recordCount.length && recordCount[0].recordCount > 0
                            && isDynamicDataLayerSource(this.currentSubLayer.source) && isGeometryDataSource(this.currentSubLayer.source.dataSource))) return [3 /*break*/, 21];
                        this.numSelectedClasses = parseInt(this.classes.nativeElement.value, 10);
                        this.colorPickerClassNo = null;
                        this.renderers = [];
                        this.destroySlider();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 19, , 20]);
                        this.isDate = false;
                        selectedColumn = this.layer.mapcoreProps.columns.filter(function (x) { return x.name === _this.selectedField; });
                        if (selectedColumn && selectedColumn.length && selectedColumn.length > 0 && selectedColumn[0] && selectedColumn[0].databaseDataType && (selectedColumn[0].databaseDataType.toUpperCase() === 'DATE' || selectedColumn[0].name.toUpperCase().indexOf('DATE') > -1)) {
                            this.isDate = true;
                        }
                        return [4 /*yield*/, this.themeService.getLayerClassBreakData(this.layer.mapcoreProps.parentId, this.selectedField, this.numSelectedClasses, this.forceUniqueValues, JSON.parse(this.currentSubLayer.source.dataSource.query), this.isDate)];
                    case 3:
                        result = _c.sent();
                        this.isNumericData = result.IsNumericData;
                        if (!(result.ClassBreakInfos.length < this.minClasses || result.ClassBreakInfos.length > this.maxClasses)) return [3 /*break*/, 11];
                        errorMessage = result.ClassBreakInfos.length < this.minClasses ? this.minError : this.maxError;
                        if (!(this.validationState === 'fresh')) return [3 /*break*/, 9];
                        if (!this.forceUniqueValues) return [3 /*break*/, 4];
                        this.validationState = 'failed';
                        this.errorMessage = errorMessage;
                        this.isNumericData = result.IsNumericData;
                        return [3 /*break*/, 8];
                    case 4:
                        if (!(this.isNumericData || this.isDate)) return [3 /*break*/, 6];
                        this.validationState = 'numeric_resetNumSelectedClasses';
                        this.classes.nativeElement.value = this.defaultNumClasses.toString();
                        return [4 /*yield*/, this.forceUpdateWithUniqueValues(false)];
                    case 5:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        this.validationState = 'nonNumeric_forcedUniqueValues';
                        return [4 /*yield*/, this.forceUpdateWithUniqueValues(true)];
                    case 7:
                        _c.sent();
                        _c.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        this.errorMessage = errorMessage;
                        this.isNumericData = result.IsNumericData;
                        this.validationState = 'failed';
                        _c.label = 10;
                    case 10: return [3 /*break*/, 18];
                    case 11:
                        this.classBreakInfos = result.ClassBreakInfos;
                        this.histogramResult = result.Histogram;
                        this.validationState = 'fresh';
                        return [4 /*yield*/, this.themeService.getSimpleLayerSymbols(this.layer)];
                    case 12:
                        symbols = _c.sent();
                        return [4 /*yield*/, this.getColorSets(result.ClassBreakInfos.length, symbols)];
                    case 13:
                        colorSets = _c.sent();
                        if (!(((this.isNumericData || this.isDate) && !this.forceUniqueValues) && isClassBreakInfo(this.classBreakInfos))) return [3 /*break*/, 15];
                        _a = this;
                        return [4 /*yield*/, this.themeService.buildNumericRenderer(this.layer, this.selectedField, result.ClassBreakInfos, symbols, colorSets)];
                    case 14:
                        _a.renderers = _c.sent();
                        this.classBreakResult = {
                            classBreakInfos: this.classBreakInfos,
                            minValue: this.classBreakInfos[0].minValue,
                            maxValue: this.classBreakInfos[this.classBreakInfos.length - 1].maxValue,
                            normalizationTotal: undefined
                        };
                        this.layerService.saveClassBreakLabels(this.layer);
                        this.themeService.saveClassBreakLabels(this.layer);
                        this.updateColorSlider(this.renderers[0], this.classBreakResult, this.histogramResult, this.newColorScheme);
                        this.appendFieldToLayerName(this.layer);
                        return [3 /*break*/, 17];
                    case 15:
                        _b = this;
                        return [4 /*yield*/, this.themeService.buildUniqueValueRenderer(this.layer, this.selectedField, result.ClassBreakInfos, symbols, colorSets)];
                    case 16:
                        _b.renderers = _c.sent();
                        this.appendFieldToLayerName(this.layer);
                        this.classes.nativeElement.disabled = true;
                        this.layerService.mapLayersSub.next();
                        this.forceUniqueValues = true;
                        _c.label = 17;
                    case 17:
                        this.layer.mapcoreProps.isThemed = true;
                        _c.label = 18;
                    case 18:
                        this.dispatchUpdateEvent();
                        return [3 /*break*/, 20];
                    case 19:
                        error_1 = _c.sent();
                        this.errorMessage = 'There was an error loading data, please try again or contact an administrator.';
                        return [3 /*break*/, 20];
                    case 20: return [3 /*break*/, 22];
                    case 21:
                        this.errorMessage = 'No records for the current layer. Theme can\'t be applied.';
                        _c.label = 22;
                    case 22:
                        this.loadingData = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.getColorSets = function (classes, symbols, currentColors) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, sublayerColors, _b, _c, _1, _d, colors, scheme, e_2_1;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        sublayerColors = [];
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(this.layer.sublayers.toArray()), _c = _b.next();
                        _e.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        _1 = _c.value;
                        return [4 /*yield*/, this.themeService.getClassColors(classes, currentColors, symbols[0], this.useSymbolScheme, this.useEsriScheme)];
                    case 3:
                        _d = tslib_1.__read.apply(void 0, [_e.sent(), 2]), colors = _d[0], scheme = _d[1];
                        this.newColorScheme = scheme;
                        sublayerColors.push(colors);
                        _e.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.currentColors = sublayerColors[0];
                        return [2 /*return*/, sublayerColors];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.dispatchUpdateEvent = function () {
        window.dispatchEvent(new CustomEvent('symbolChange', { detail: this.layerId }));
    };
    ThemeEditorComponent.prototype.updateMinMax = function () {
        if (this.forceUniqueValues) {
            this.minClasses = this.themeService.minMaxes.unique.min;
            this.maxClasses = this.themeService.minMaxes.unique.max;
        }
        else {
            this.minClasses = this.themeService.minMaxes.range.min;
            this.maxClasses = this.themeService.minMaxes.range.max;
        }
    };
    ThemeEditorComponent.prototype.appendFieldToLayerName = function (layer) {
        var _this = this;
        var column = this.layerColumns.find(function (lc) { return lc.name.toLowerCase() === _this.selectedField.toLowerCase(); });
        if (layer.mapcoreProps.name.match(/(\(Theme Field: ).*?(\))(?!.*\2)/g)) {
            layer.mapcoreProps.name = layer.mapcoreProps.name.replace(/(\(Theme Field: ).*?(\))(?!.*\2)/g, "$1" + column.alias + "$2");
        }
        else {
            layer.mapcoreProps.name = layer.mapcoreProps.name + " (Theme Field: " + column.alias + ")";
        }
    };
    ThemeEditorComponent.prototype.removeFieldFromLayerName = function (layer) {
        if (layer.mapcoreProps.name.match(/(\(Theme Field: ).*?(\))(?!.*\2)/g)) {
            layer.mapcoreProps.name = layer.mapcoreProps.name.replace(/(\(Theme Field: ).*?(\))(?!.*\2)/g, '').trim();
        }
    };
    // If manual classification method is selected, then create
    // a classed color slider to allow user to manually modify
    // the class breaks starting with the generated renderer
    ThemeEditorComponent.prototype.updateColorSlider = function (renderer, classBreaksResult, histogramResult, newColorScheme) {
        var _this = this;
        var rendererResult = {
            renderer: renderer,
            classBreaksResult: classBreaksResult,
            colorScheme: newColorScheme.primaryScheme,
            defaultValuesUsed: false,
            basemapId: this.mapViewRef.map.basemap.id
        };
        this.sliderContainerDiv = document.createElement('div');
        this.sliderContainerDiv.id = 'sliderContainerDiv';
        this.sliderContainer.nativeElement.appendChild(this.sliderContainerDiv);
        this.slider = this.ClassedColorSlider.fromRendererResult(rendererResult, histogramResult);
        this.slider.container = this.sliderContainerDiv;
        this.slider.viewModel.precision = 1; // TODO: Find a way to check for int vs decimal
        this.changeEventHandler(false);
        this.slider.on('thumb-drag', function () { return _this.changeEventHandler(true); });
        this.slider.on('thumb-change', function () { return _this.changeEventHandler(true); });
        var observer = new MutationObserver(function () {
            if (_this.sliderContainerDiv.contains(_this.sliderContainerDiv.getElementsByClassName('esri-slider')[0])) {
                _this.sliderContainerDiv.setAttribute('style', 'height: 100%;');
                _this.sliderContainerDiv.getElementsByClassName('esri-classed-color-slider__slider-container')[0].setAttribute('style', 'height: 100%');
                var esriSlider = _this.sliderContainerDiv.getElementsByClassName('esri-slider')[0];
                esriSlider.setAttribute('style', 'height: 100%');
                observer.disconnect();
            }
        });
        observer.observe(this.sliderContainerDiv, { attributes: false, childList: true, characterData: false, subtree: true });
    };
    ThemeEditorComponent.prototype.changeEventHandler = function (userChangedClassBreak) {
        var e_3, _a, e_4, _b, e_5, _c, e_6, _d;
        var usingOriginalLayerFilter = this.layer.mapcoreProps.classBreakLabels === this.themeService.getClassBreakLabels(this.layer);
        var themeColors = this.themeService.getColorsForField(this.layer, this.selectedField);
        try {
            for (var _e = tslib_1.__values(this.layer.sublayers.toArray()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var sublayer = _f.value;
                if (isClassBreaksRenderer(sublayer.renderer)) {
                    var originalClassBreaks = sublayer.renderer.classBreakInfos;
                    var renderer = sublayer.renderer.clone();
                    renderer.classBreakInfos = this.slider.updateClassBreakInfos(renderer.classBreakInfos);
                    sublayer.renderer = renderer;
                    try {
                        for (var _g = tslib_1.__values(renderer.classBreakInfos.entries()), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var _j = tslib_1.__read(_h.value, 2), index = _j[0], classBreak = _j[1];
                            var originalLabel = originalClassBreaks[index].label;
                            var newLabel = "Break-" + classBreak.minValue;
                            classBreak.value = newLabel;
                            classBreak.label = newLabel;
                            try {
                                for (var _k = tslib_1.__values(this.renderers), _l = _k.next(); !_l.done; _l = _k.next()) {
                                    var r = _l.value;
                                    r.classBreakInfos[index].label = newLabel;
                                    r.classBreakInfos[index].value = newLabel;
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            if (usingOriginalLayerFilter && originalLabel !== newLabel && originalLabel in themeColors) {
                                // Save the class break's color if its label changes
                                var color = themeColors[originalClassBreaks[index].label];
                                this.themeService.forgetColor(this.layer, this.selectedField, originalClassBreaks[index].label);
                                this.themeService.saveColor(this.layer, this.selectedField, classBreak.value, color);
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    this.classBreakResult.classBreakInfos = renderer.classBreakInfos;
                    try {
                        for (var _m = tslib_1.__values(this.renderers), _o = _m.next(); !_o.done; _o = _m.next()) {
                            var r = _o.value;
                            if (isClassBreaksRenderer(r)) {
                                for (var i = 0; i < r.classBreakInfos.length; i++) {
                                    r.classBreakInfos[i].maxValue = renderer.classBreakInfos[i].maxValue;
                                    r.classBreakInfos[i].minValue = renderer.classBreakInfos[i].minValue;
                                }
                            }
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.layerService.mapLayersSub.next();
        if (userChangedClassBreak && usingOriginalLayerFilter) {
            this.layerService.saveClassBreakLabels(this.layer);
            this.themeService.saveClassBreakLabels(this.layer);
        }
    };
    ThemeEditorComponent.prototype.openClassColorPicker = function (index, color) {
        this.colorPickerClassNo = index;
        this.tempColor = color;
    };
    ThemeEditorComponent.prototype.updateColorFromPicker = function (evt, index, valueType) {
        var e_7, _a, e_8, _b;
        try {
            for (var _c = tslib_1.__values(this.renderers), _d = _c.next(); !_d.done; _d = _c.next()) {
                var sublayer = _d.value;
                var temp = sublayer[valueType];
                temp[index].symbol.color = evt;
                if (temp[index].symbol.style === 'none') {
                    temp[index].symbol.outline.color = evt;
                }
                sublayer[valueType] = temp;
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_7) throw e_7.error; }
        }
        try {
            for (var _e = tslib_1.__values(this.layer.sublayers.toArray()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var sublayer = _f.value;
                sublayer.renderer[valueType][index].symbol.color = evt;
                if (sublayer.renderer[valueType][index].symbol.style === 'none') {
                    sublayer.renderer[valueType][index].symbol.outline.color = evt;
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_8) throw e_8.error; }
        }
        this.layer.refresh();
        if (valueType === 'classBreakInfos') {
            this.destroySlider();
            this.updateColorSlider(this.renderers[0], this.classBreakResult, this.histogramResult, this.newColorScheme);
        }
        else {
            this.layerService.mapLayersSub.next();
        }
        this.saveCustomColor(evt, index, valueType);
        this.dispatchUpdateEvent();
    };
    ThemeEditorComponent.prototype.cancelColorPicker = function (index, valueType) {
        var e_9, _a;
        try {
            for (var _b = tslib_1.__values(this.renderers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var sublayer = _c.value;
                sublayer[valueType][index].symbol.color = this.tempColor;
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
        this.colorPickerClassNo = null;
        if (valueType === 'classBreakInfos') {
            this.destroySlider();
            this.updateColorSlider(this.renderers[0], this.classBreakResult, this.histogramResult, this.newColorScheme);
        }
        this.layer.refresh();
    };
    ThemeEditorComponent.prototype.saveCustomColor = function (color, index, valueType) {
        var infos = this.renderers[0][valueType];
        this.themeService.saveColor(this.layer, this.selectedField, infos[index].value, color);
    };
    ThemeEditorComponent.prototype.destroySlider = function () {
        if (this.slider) {
            this.sliderContainerDiv.parentNode.removeChild(this.sliderContainerDiv);
            this.slider.container = null;
            this.slider = null;
            this.sliderContainerDiv = null;
        }
        this.classes.nativeElement.disabled = false;
    };
    ThemeEditorComponent.prototype.destroyComponent = function () {
        if (this.layer && !this.keepThemeOnOriginalLayer) {
            this.removeTheme();
        }
        this.numSelectedClasses = this.defaultNumClasses;
        this.errorMessage = null;
        this.loadingData = false;
        this.colorPickerClassNo = null;
        this.classBreakInfos = [];
        this.currentColors = [];
        this.renderers = [];
        this.symbol = [];
        this.dispatchUpdateEvent();
    };
    ThemeEditorComponent.prototype.themeLayer = function () {
        this.keepThemeOnOriginalLayer = true;
        this.closeWindow();
    };
    ThemeEditorComponent.prototype.closeWindow = function () {
        this.classInputSub.unsubscribe();
        if (this.windowRef) {
            this.windowRef.close();
        }
    };
    ThemeEditorComponent.prototype.deThemeLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.keepThemeOnOriginalLayer = false;
                this.closeWindow();
                this.themeService.forgetTheme(this.layer);
                return [2 /*return*/];
            });
        });
    };
    ThemeEditorComponent.prototype.removeTheme = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_10, _a, _b, SimpleRenderer, rendererDefinitions, i, newRendererDefinition, _c, _d, _e, sublayer, index, renderer;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.layer) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.SimpleRenderer])];
                    case 1:
                        _b = tslib_1.__read.apply(void 0, [_f.sent(), 1]), SimpleRenderer = _b[0];
                        rendererDefinitions = [];
                        for (i = 0; i < this.layer.sublayers.length; i++) {
                            if (this.layer.mapcoreProps.simpleRenderers) {
                                rendererDefinitions.push(this.layer.mapcoreProps.simpleRenderers[i]);
                            }
                            else {
                                newRendererDefinition = this.themeService.getNewRendererForSublayer(this.layer.sublayers.getItemAt(i));
                                rendererDefinitions.push(newRendererDefinition);
                                if (isSymbolPropertiesWithOutline(newRendererDefinition.symbol)) {
                                    newRendererDefinition.symbol.outline.color = newRendererDefinition.symbol.color;
                                }
                            }
                        }
                        delete this.layer.mapcoreProps.simpleRenderers;
                        try {
                            //Then set the new renderer
                            for (_c = tslib_1.__values(this.layer.sublayers.toArray().map(function (s, i) { return ({ sublayer: s, index: i }); })), _d = _c.next(); !_d.done; _d = _c.next()) {
                                _e = _d.value, sublayer = _e.sublayer, index = _e.index;
                                renderer = rendererDefinitions[index];
                                sublayer.renderer = new SimpleRenderer({ symbol: renderer.symbol });
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        this.removeFieldFromLayerName(this.layer);
                        this.themeService.forgetTheme(this.layer);
                        this.layer.mapcoreProps.isThemed = false;
                        this.layerService.mapLayersSub.next();
                        this.layerService.layersRefreshed.emit();
                        _f.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.splitLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var field_1, column, groupParent, currentQuery, firstRenderer, infos, i, label, subquery, isLastBreak, renderers, layers, group;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.layerColumns) return [3 /*break*/, 2];
                        field_1 = this.renderers[0].field;
                        column = this.layerColumns.find(function (x) { return x.name === field_1; });
                        groupParent = {
                            layers: [],
                            name: this.layer.mapcoreProps.name,
                            checked: true
                        };
                        currentQuery = (this.layer.mapcoreProps.query && this.layer.mapcoreProps.query.subqueries) ? this.layer.mapcoreProps.query.subqueries : [this.layer.mapcoreProps.query];
                        firstRenderer = this.renderers[0];
                        infos = isClassBreaksRenderer(firstRenderer) ? firstRenderer.classBreakInfos : firstRenderer.uniqueValueInfos;
                        for (i = 0; i < infos.length; i++) {
                            label = '';
                            subquery = [];
                            if (this.layerService.isProperQuery(this.layer.mapcoreProps.query)) {
                                subquery.push.apply(subquery, tslib_1.__spread(currentQuery));
                            }
                            if (isClassBreakInfo(infos)) {
                                label = infos[i].minValue + "-" + infos[i].maxValue;
                                isLastBreak = (i === infos.length - 1);
                                subquery.push(this.buildRangeQuery(infos[i], field_1, isLastBreak));
                            }
                            else {
                                label = infos[i].label;
                                subquery.push(this.buildUniqueQuery(infos[i], field_1));
                            }
                            renderers = this.getSimpleRenderersForClass(i);
                            groupParent.layers.push({
                                id: this.layer.mapcoreProps.parentId,
                                visible: true,
                                groupParent: groupParent,
                                name: (column && column.alias ? column.alias : field_1) + " (" + label + ")",
                                renderers: renderers,
                                query: {
                                    operator: 'AND',
                                    subqueries: subquery
                                },
                                opacity: this.layer.opacity,
                                parentQuery: this.layer.mapcoreProps.parentQuery
                            });
                        }
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(groupParent.layers)];
                    case 1:
                        layers = _a.sent();
                        group = layers.find(function (layer) { return layer.type === 'group'; });
                        group.layers.reverse();
                        this.layerService.moveLayerAbove(group, this.layer);
                        this.layer.visible = false;
                        this.keepThemeOnOriginalLayer = false;
                        this.closeWindow();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ThemeEditorComponent.prototype.buildRangeQuery = function (classBreak, filterField, lastBreak) {
        if (lastBreak === void 0) { lastBreak = false; }
        return {
            operator: 'AND',
            subqueries: [
                {
                    field: filterField,
                    operator: '>=',
                    value: classBreak.minValue.toString()
                },
                {
                    field: filterField,
                    operator: lastBreak ? '<=' : '<',
                    value: classBreak.maxValue.toString()
                }
            ]
        };
    };
    ThemeEditorComponent.prototype.buildUniqueQuery = function (classBreak, filterField) {
        var val = classBreak.value === null ? 'null' : classBreak.value.toString();
        return {
            operator: 'AND',
            isHiddenFilter: true,
            subqueries: [
                {
                    field: filterField,
                    operator: val.toLowerCase() === 'null' ? 'IS NULL' : '=',
                    value: val.toLowerCase() === 'null' ? null : val
                }
            ]
        };
    };
    ThemeEditorComponent.prototype.getSimpleRenderersForClass = function (infoIndex) {
        var e_11, _a;
        var renderers = [];
        try {
            for (var _b = tslib_1.__values(this.layer.sublayers.toArray()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var sublayer = _c.value;
                var r = sublayer.renderer;
                if (isClassBreaksRenderer(r)) {
                    renderers.push({ type: 'simple', symbol: r.classBreakInfos[infoIndex].symbol, visualVariables: this.layer.mapcoreProps.simpleRenderers[0].visualVariables });
                }
                else if (isUniqueValueRenderer(r)) {
                    renderers.push({ type: 'simple', symbol: r.uniqueValueInfos[infoIndex].symbol, visualVariables: this.layer.mapcoreProps.simpleRenderers[0].visualVariables });
                }
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_11) throw e_11.error; }
        }
        return renderers;
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ThemeEditorComponent.prototype, "useEsriScheme", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ThemeEditorComponent.prototype, "useSymbolScheme", void 0);
    return ThemeEditorComponent;
}(BaseComponent));
export { ThemeEditorComponent };
